import styled, { AnyStyledComponent } from 'styled-components';
import { ButtonShapes, IndividualButtonSizes, ButtonStyles } from './button.types';
import COLORS from '../../style/universal.color';
import { MLBTheme } from '../../style/theme.types';

interface styledButtonProps {
  sizeStyles: IndividualButtonSizes,
  hSpeed: number,
  shape: ButtonShapes,
  backgroundColor: string,
  borderless: boolean,
  borderColor: string,
  onlyIcon: boolean,
  color: string,
  iconColor: string,
  icon: boolean,
  iconLeft: boolean,
  disabled: boolean,
  hasHover: boolean,
  hoverBackgroundColor: string,
  hoverColor: string,
  hoverBorderColor: string,
  iconHoverColor: string,
  theme: MLBTheme,
  styleName: ButtonStyles,
  active: boolean,
}

export const Label: AnyStyledComponent = styled.span`
  display: inline-block;
`;

export const StyledButton: AnyStyledComponent = styled.button`
  height: ${ ({sizeStyles}: styledButtonProps) => sizeStyles['height'] }px;
  padding-left: ${ ({sizeStyles}: styledButtonProps) => sizeStyles['horizontalPadding'] }px;
  padding-right: ${ ({sizeStyles}: styledButtonProps) => sizeStyles['horizontalPadding'] }px;
  font-size: ${ ({sizeStyles}: styledButtonProps) => sizeStyles['fontSize'] }px;

  ${ ({hasHover, hSpeed}: styledButtonProps) => hasHover ? `transition: ${ hSpeed }s };` : ''}
  border-radius: ${ ({shape, sizeStyles}: styledButtonProps) => shape === ButtonShapes.TAB ? 
    '0px' : shape === ButtonShapes.PILL ? `${sizeStyles['height']/2}px` : '5px' };
  font-weight: bold;
  vertical-align: bottom;

  ${ ({backgroundColor, active, hoverBackgroundColor}: styledButtonProps) => {
    const color = active && hoverBackgroundColor ? hoverBackgroundColor : backgroundColor;

    return color ? `background-color: ${ color };` : '';
  } }
  ${ ({borderless, borderColor, onlyIcon, active, hoverBorderColor}: styledButtonProps) => {
    const color = active && hoverBorderColor ? hoverBorderColor : borderColor;

    return !borderless && color && !(ButtonShapes.PILL && onlyIcon)
    ? `border: 1px solid ${ color };`
    : `border: none;`
  }}
  ${ ({color, active, hoverColor}: styledButtonProps) => {
    const btnColor = active && hoverColor ? hoverColor : color;

    return btnColor ? `color: ${ btnColor };` : '';
  }}
  svg {
    padding-top: ${ ({sizeStyles}: styledButtonProps) => sizeStyles['iconPaddingTop']}px;
    vertical-align: top;
    fill: ${ ({iconColor, color}: styledButtonProps) => iconColor || color };
    path {
      fill: ${ ({iconColor, color}: styledButtonProps) => iconColor || color };
    }
  }
  ${Label} {
    ${ ({icon, onlyIcon, iconLeft}: styledButtonProps) => icon && iconLeft && !onlyIcon ? 'margin-left: 5px;' : ''}
    ${ ({icon, onlyIcon, iconLeft}: styledButtonProps) => icon && !iconLeft && !onlyIcon ? 'margin-right: 5px;' : ''}
    font-family: ${({ theme = {}}: styledButtonProps) => theme.fonts?.family?.primary};
  }

  &:hover {
    ${ ({disabled}: styledButtonProps) => !disabled ? 'cursor: pointer;' : ''}
    ${({ shape, theme }: styledButtonProps) => shape === ButtonShapes.TAB ? `border-bottom: 3px solid ${theme.primaryLinkHoverColor}` : ''}
    ${ ({hasHover, hoverBackgroundColor, hoverColor, borderless, hoverBorderColor, iconHoverColor, iconColor, color}: styledButtonProps) =>
    hasHover 
    ? (
      `
      ${ hoverBackgroundColor ? `background-color: ${ hoverBackgroundColor };` : ''}
      ${ hoverColor ? `color: ${ hoverColor };` : ''}
      ${ !borderless && hoverBorderColor ? `border: 1px solid ${ hoverBorderColor };` : ''}
      svg {
        fill: ${ iconHoverColor || iconColor || color };
        path {
          fill: ${ iconHoverColor || iconColor || color };
        }
      }
      `
      )
      : ''
    }
  }
  ${({ shape, theme }: styledButtonProps) => shape === ButtonShapes.TAB ? `
    background: transparent;
    border: 0;
    border-bottom: 3px solid ${COLORS.transparent};
    color: ${theme.disabledLinkColor};
    margin-right: 5px;
    margin-top: 6px;
    padding: 6px 12px;
    position: relative;
  ` : ''}
  ${({ styleName, theme }: styledButtonProps) => styleName === ButtonStyles.SELECTED_TAB ? `
    color: ${theme?.primaryTextColor};
    border-bottom: 3px solid ${theme.primaryLinkColor};
  ` : ''}
`;
